var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2101_5171)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.66659 2.66665V1.33331H11.3333V2.66665H14.6666V3.99998H13.3333V14C13.3333 14.1768 13.263 14.3464 13.138 14.4714C13.013 14.5964 12.8434 14.6666 12.6666 14.6666H3.33325C3.15644 14.6666 2.98687 14.5964 2.86185 14.4714C2.73682 14.3464 2.66659 14.1768 2.66659 14V3.99998H1.33325V2.66665H4.66659ZM3.99992 3.99998V13.3333H11.9999V3.99998H3.99992ZM5.99992 5.99998H7.33325V11.3333H5.99992V5.99998ZM8.66659 5.99998H9.99992V11.3333H8.66659V5.99998Z",
    fill: "#05141F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2101_5171"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.51676d2c22a71074b7d0bdb47e35bbd1.svg";
export { ForwardRef as ReactComponent };